/* Progressive catalog filters: native GET URLs, accessible controls and no fake client matches.
   Desktop checkbox changes apply instantly. Mobile groups selections in a sticky Apply action.
   Price inputs use an explicit action and refuse inverted bounds with a visible explanation.
 */
(() => {
  'use strict';
  const origins = new WeakMap();
  const scrollKey = 'leonparc:catalog:restore-scroll';

  function rememberScroll() {
    try {
      sessionStorage.setItem(scrollKey, JSON.stringify({
        path: location.pathname, scrollY: window.scrollY, recordedAt: Date.now()
      }));
    } catch (_) {}
  }
  function restoreScroll() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(scrollKey) || 'null');
      sessionStorage.removeItem(scrollKey);
      if (!saved || saved.path !== location.pathname || Date.now() - saved.recordedAt > 15000) return;
      requestAnimationFrame(() => window.scrollTo({ top: Math.max(0, saved.scrollY), behavior: 'instant' }));
    } catch (_) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScroll, { once: true });
  } else restoreScroll();

  function pending(form) {
    const label = form.querySelector('[data-catalog-filter-pending]');
    if (label) label.hidden = false;
  }
  function clearBudgetError(form) {
    const error = form.querySelector('[data-catalog-filter-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
  }
  function validateBudget(form) {
    clearBudgetError(form);
    const min = form.querySelector('[name="filter.v.price.gte"]');
    const max = form.querySelector('[name="filter.v.price.lte"]');
    if (!min || !max || min.value === '' || max.value === '') return true;
    if (Number(min.value) <= Number(max.value)) return true;
    const error = form.querySelector('[data-catalog-filter-error]');
    if (error) {
      error.textContent = 'De maximumprijs moet hoger zijn dan of gelijk zijn aan de minimumprijs.';
      error.hidden = false;
    }
    max.focus();
    return false;
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-catalog-filter-open]');
    if (trigger) {
      const dialog = trigger.closest('[data-catalog-root]')?.querySelector('dialog[data-catalog-filter-dialog]');
      if (dialog && typeof dialog.showModal === 'function') {
        origins.set(dialog, trigger);
        dialog.showModal();
        dialog.querySelector('[data-catalog-filter-close]')?.focus();
      }
      return;
    }
    const close = event.target.closest('[data-catalog-filter-close]');
    if (close) { close.closest('dialog[data-catalog-filter-dialog]')?.close(); return; }
    if (event.target.matches('dialog[data-catalog-filter-dialog][open]')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
    if (event.target.closest('.lp-catalog__applied a, .lp-catalog__sidebar .lp-facet-form__reset, .lp-catalog__drawer .lp-facet-form__reset')) {
      rememberScroll();
    }
  });

  document.addEventListener('close', (event) => {
    if (!(event.target instanceof HTMLDialogElement) || !event.target.matches('[data-catalog-filter-dialog]')) return;
    const opener = origins.get(event.target);
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  }, true);

  document.addEventListener('input', (event) => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches('.lp-facet-form input[type="number"]')) return;
    clearBudgetError(event.target.form);
    if (event.target.closest('[data-catalog-filter-dialog]')) pending(event.target.form);
  });
  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLSelectElement && event.target.matches('[data-catalog-sort]')) {
      rememberScroll();
      event.target.form?.requestSubmit();
      return;
    }
    if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'checkbox') return;
    const form = event.target.closest('form[data-catalog-facet-form]');
    if (!form) return;
    if (event.target.closest('[data-catalog-filter-dialog]')) {
      pending(form);
      return;
    }
    if (!event.target.closest('.lp-catalog__sidebar')) return;
    if (!validateBudget(form)) return;
    rememberScroll();
    form.requestSubmit();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[data-catalog-facet-form]')) return;
    if (!validateBudget(form)) { event.preventDefault(); return; }
    rememberScroll();
    const submitter = event.submitter;
    if (submitter instanceof HTMLButtonElement) {
      const buttonText = submitter.querySelector('span[data-submit-label]');
      if (buttonText) buttonText.textContent = 'Filters toepassen…';
    }
  });
})();
